document.addEventListener('DOMContentLoaded', () => {
  // --- Pill menu toggle ---
  const toggleBtn = document.querySelector('.js-open-menu');
  const menuPill = document.querySelector('.js-header-menu-pill');

  if (toggleBtn && menuPill) {
    toggleBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = menuPill.classList.contains('is-open');
      menuPill.classList.toggle('is-open', !isOpen);
      toggleBtn.setAttribute('aria-expanded', String(!isOpen));
    });

    // Close when clicking outside the button/pill
    document.addEventListener('click', (e) => {
      if (!menuPill.classList.contains('is-open')) return;
      if (menuPill.contains(e.target) || toggleBtn.contains(e.target)) return;
      menuPill.classList.remove('is-open');
      toggleBtn.setAttribute('aria-expanded', 'false');
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && menuPill.classList.contains('is-open')) {
        menuPill.classList.remove('is-open');
        toggleBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // --- Hide header on scroll down, show on scroll up ---
  const header = document.querySelector('.custom-header');
  if (header) {
    const HIDE_THRESHOLD = 80; // don't hide until scrolled this far, avoids flicker near the top
    let lastScrollY = window.scrollY;
    let ticking = false;

    const updateHeaderVisibility = () => {
      const currentScrollY = window.scrollY;
      const menuIsOpen = menuPill && menuPill.classList.contains('is-open');

      if (menuIsOpen || currentScrollY <= HIDE_THRESHOLD) {
        header.classList.remove('is-hidden');
      } else if (currentScrollY > lastScrollY) {
        header.classList.add('is-hidden');
      } else if (currentScrollY < lastScrollY) {
        header.classList.remove('is-hidden');
      }

      lastScrollY = currentScrollY;
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateHeaderVisibility);
    });
  }

  // --- Dynamic cart bubble updating ---
  // Always registers, independently of the pill menu above — the cart bubble
  // has to stay in sync on pages where no menu is rendered at all.
  document.addEventListener('cart:update', (event) => {
    const cartCountEls = document.querySelectorAll('.js-cart-count');
    if (!cartCountEls.length) return;

    const cart = event.detail?.resource;
    if (cart && typeof cart.item_count !== 'undefined') {
      updateCartCount(cart.item_count);
    } else {
      fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          if (typeof data.item_count !== 'undefined') {
            updateCartCount(data.item_count);
          }
        })
        .catch(error => console.error('Error fetching cart:', error));
    }

    function updateCartCount(count) {
      cartCountEls.forEach(el => {
        // Writes into the inner .cart-count__number span, not this element's
        // own textContent — this element also carries the globe background
        // image, and a bare textContent assignment would wipe out the number
        // span (and the CSS transform scoped to it) on every cart update.
        const numberEl = el.querySelector('.cart-count__number');
        if (numberEl) {
          numberEl.textContent = count;
        } else {
          el.textContent = count;
        }
        el.classList.toggle('hidden', count === 0);
      });
    }
  });
});
